import React from 'react';
import { connect } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
import { Button, Row, Col, Modal, ModalHeader, ModalBody, Alert } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { translate } from 'react-jhipster';
import { formatterDate } from 'app/shared/util/date-utils';
import ComponentDatePicker from 'app/shared/component/ComponentDatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCheckCircle, faExclamationTriangle, faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
import { colors } from 'app/config/color';
import {
  ENP,
  BORN_PLACE,
  NATIVE_VILLAGE,
  RESIDENT,
  APP_LOCAL_DATE_FORMAT,
  SUCCESS,
  IND,
  ORG,
  ADD,
  Resources,
  claim,
  KEY_STORAGE
} from 'app/config/constants';
import ModalSelectInfo from './modal-select-info';
import {
  getDistrict,
  getGuild,
  updateAttribute,
  uploadFile,
  getFile,
  appovalCreate,
  updateAccount,
  handleGetUserInfo
} from '../user.reducer';
import '../../user/profile.scss';
import moment from 'moment';
import MessageModal from 'app/shared/message/message-modal';
import MessageModalConfirm from '../../user/messageModalConfirm';
import ModalResources from './modal-resources';
import ModalUpdateAttribute from '../modal-update-attribute';
import AlertMessage from 'app/view-common/AlertMessage';
import ModalListFile from 'app/modules/account/user/identity-info/modal-list-file';
import { forEach } from 'lodash';
import { handleDeleteUserByIdApprove } from 'app/modules/administration/approve-management/approve-management.reducer';

export interface IUpdateIdentityProps extends StateProps, DispatchProps {
  isDisplay: boolean;
  infoUserProfile: any;
  invokeCloseModal: Function;
  dictInfoSelect: any;
  updateInfoWithResource: boolean;
  type: any;
}

export interface IUpdateIdentityState {
  birthday: Date;
  requiredDate: boolean;
  isDisplayModalSelectInfo: boolean;
  typeInput: string;
  isClearBirthPlace: boolean;
  isClearOriginLocal: boolean;
  isClearPermanentAddress: boolean;
  isClearCurrentAddress: boolean;
  birthPlace: string;
  originLocal: string;
  permanentAddress: string;
  currentAddress: string;
  showMessageUpdateInfo: boolean;
  disabelBtnUpdate: boolean;
  isDisplayModalConfirm: boolean;
  messageConfirm: string;
  dataInput: any;
  isChangeBirthPlace: boolean;
  isChangeOriginLocal: boolean;
  isChangePermanentAddress: boolean;
  isChangeCurrentAddress: boolean;
  displayModalResources: boolean;
  infoIdentity: any;
  showModalAttribute: boolean;
  showMessageError: boolean;
  messageError: string;
  stringType: string;
  showMessage: boolean;
  fileComputer: any;
  displayModalListFile: boolean;
  isVerifyResidentialFail: boolean;
  visible: boolean;
  color: string;
  message: string;
}

var HOMETOWN = 'homeTown';
var arrKeyIND = ['cn', 'gender', 'dateOfBirth', 'birthPlace', 'identity', 'citizenId', 'originLocal', 'permanentAddress', 'mobile', 'mail'];
var arrKeyENP = ['organization', 'tax', 'mobile', 'mail', 'add'];
var arrKeyORG = ['organization', 'unitCode', 'mobile', 'mail', 'add', 'unit'];
// info send to modal select info
var valueProvince = '';
var valueDistrict = '';
var valueWard = '';
var valueAddress = '';
var isUpdateInfo = false;
var arrWard = [];
var arrDistrict = [];
const BIRTH_PLACE = 'birthPlace';
var updateInfoWithResouce = false;
var sources = '';
var oldData = {};
var initialDataIND = {
  dob: '',
  mobile: '',
  email: ''
};

var initialDataORG = {
  unitCode: '',
  mobile: '',
  email: '',
  organization: ''
};

export class UpdateIdentity extends React.Component<IUpdateIdentityProps, IUpdateIdentityState> {
  state: IUpdateIdentityState = {
    visible: false,
    color: 'danger',
    message: '',
    birthday: null,
    requiredDate: false,
    isDisplayModalSelectInfo: false,
    typeInput: '',
    isClearBirthPlace: false,
    isClearOriginLocal: false,
    isClearPermanentAddress: false,
    isClearCurrentAddress: false,
    birthPlace: '',
    originLocal: '',
    permanentAddress: '',
    currentAddress: '',
    showMessageUpdateInfo: false,
    disabelBtnUpdate: false,
    isDisplayModalConfirm: false,
    messageConfirm: '',
    dataInput: {},
    isChangeBirthPlace: false,
    isChangeOriginLocal: false,
    isChangePermanentAddress: false,
    isChangeCurrentAddress: false,
    displayModalResources: false,
    infoIdentity: null,
    showModalAttribute: false,
    showMessageError: false,
    messageError: '',
    stringType: '',
    showMessage: false,
    displayModalListFile: false,
    fileComputer: null,
    isVerifyResidentialFail: false
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.resUpdateAttr !== nextProps.resUpdateAttr) {
      const { resUpdateAttr } = nextProps;
      if (resUpdateAttr == null) {
        this.setState({
          showMessageError: true,
          messageError:
            'Thực hiện cập nhật dữ liệu không thành công do có lỗi xảy ra trong quá trình kết nối đến ' +
            (sources == '' ? 'CSDL Quốc gia về Dân cư' : sources),
          isVerifyResidentialFail: false
        });
        localStorage.removeItem(KEY_STORAGE.UPDATE_DATA_RESIDENTIAL);
        return;
      }
      this.setState({
        isChangeCurrentAddress: false
      });
      if (resUpdateAttr && resUpdateAttr.status === SUCCESS) {
        if (updateInfoWithResouce || this.props.updateInfoWithResource) {
          this.setState({
            displayModalResources: false,
            showModalAttribute: true,
            isVerifyResidentialFail: false
          });
        } else {
          if (resUpdateAttr.dataSources == 'CSDL Quốc gia về Dân cư') {
            this.setState({
              showModalAttribute: true,
              disabelBtnUpdate: false,
              isVerifyResidentialFail: false
            });
            localStorage.removeItem(KEY_STORAGE.UPDATE_DATA_RESIDENTIAL);
          } else {
            this.setState({
              showMessageUpdateInfo: true,
              disabelBtnUpdate: false,
              isVerifyResidentialFail: false
            });
            let _ = setTimeout(() => {
              this.setState({
                showMessageUpdateInfo: false
              });
              this.props.invokeCloseModal();
            }, 2000);
          }
        }
      } else {
        if ((updateInfoWithResouce || this.props.updateInfoWithResource) && resUpdateAttr.dataSources != 'CSDL Quốc gia về Dân cư') {
          if (
            resUpdateAttr.infoInValid == undefined ||
            resUpdateAttr.infoValid == undefined ||
            (resUpdateAttr.status === 'ERROR' && resUpdateAttr.message !== '')
          ) {
            this.setState({
              showMessageError: true,
              showModalAttribute: false,
              messageError: resUpdateAttr.message,
              isVerifyResidentialFail: false
            });
          } else {
            this.setState({
              displayModalResources: false,
              showModalAttribute: true,
              messageError: '',
              isVerifyResidentialFail: false
            });
          }
        } else {
          let dataSources = JSON.parse(localStorage.getItem(KEY_STORAGE.UPDATE_DATA_RESIDENTIAL));
          if (resUpdateAttr.dataSources == 'CSDL Quốc gia về Dân cư' && resUpdateAttr.message == '') {
            this.setState({
              disabelBtnUpdate: false,
              showModalAttribute: true,
              isVerifyResidentialFail: true
            });
            localStorage.removeItem(KEY_STORAGE.UPDATE_DATA_RESIDENTIAL);
          } else if (resUpdateAttr.dataSources == 'CSDL Quốc gia về Dân cư' && resUpdateAttr.message != '') {
            this.setState({
              showMessageError: true,
              showModalAttribute: false,
              messageError: resUpdateAttr.message,
              isVerifyResidentialFail: false
            });
            localStorage.removeItem(KEY_STORAGE.UPDATE_DATA_RESIDENTIAL);
          } else if (dataSources == 'CSDL Quốc gia về Dân cư') {
            this.setState({
              showMessageError: true,
              showModalAttribute: false,
              messageError: resUpdateAttr.message,
              isVerifyResidentialFail: false
            });
            localStorage.removeItem(KEY_STORAGE.UPDATE_DATA_RESIDENTIAL);
          } else {
            this.setState({
              disabelBtnUpdate: false,
              showModalAttribute: false,
              isVerifyResidentialFail: false
            });
          }
        }
      }
    }
    if (this.props.resultData != nextProps.resultData) {
      if (nextProps.resultData.status == 'SUCCESS') {
        this.setState({
          displayModalResources: false,
          infoIdentity: null,
          showMessage: true
        });
        setTimeout(() => {
          this.setState({
            showMessage: false,
            displayModalResources: false
          });
        }, 2000);
        this.props.invokeCloseModal();
      }
    }

    if (this.props.resultUpdate != nextProps.resultUpdate) {
      if (nextProps.resultUpdate.status == 'SUCCESS') {
        this.setState({
          displayModalResources: false,
          infoIdentity: null,
          showMessage: true
        });
        setTimeout(() => {
          this.setState({
            showMessage: false,
            displayModalResources: false
          });
        }, 2000);
        this.props.invokeCloseModal();
      } else if (nextProps.resultUpdate) {
        this.setState({
          visible: true,
          message: nextProps.resultUpdate.message
        });
      }
    }
  }

  toggle = () => {
    this.setState({
      isClearBirthPlace: false,
      isClearOriginLocal: false,
      isClearPermanentAddress: false,
      isClearCurrentAddress: false,
      isChangeBirthPlace: false,
      isChangeOriginLocal: false,
      isChangePermanentAddress: false,
      isChangeCurrentAddress: false,
      birthday: null,
      requiredDate: false
    });
    this.props.invokeCloseModal();
  };
  handleValidSubmitIdentityInfo = (event, values) => {
    if (this.props.userProfile.userType == IND) {
      if (this.state.birthday == null && !values.dateOfBirth) {
        this.setState({
          requiredDate: true
        });
        return;
      } else {
        this.setState({
          requiredDate: false
        });
      }
      values.dateOfBirth = this.state.birthday ? this.state.birthday.toDateString() : values.dateOfBirth;
    }

    this.updateInfo(values);
  };

  updateInfo = values => {
    if (this.props.infoUserProfile && this.props.infoUserProfile.attributes) {
      this.props.infoUserProfile.attributes.map(item => {
        Object.keys(values).map(function(key) {
          if (item.name === key && key === 'dateOfBirth') {
            item.value = moment(values[key]).format(APP_LOCAL_DATE_FORMAT);
            return;
          }
          if (item.name === key) {
            item.value = values[key] ? values[key].trim() : values[key];
            if (item.id == '') {
              item.id = null;
            }
            return;
          }
        });
      });
    }
    this.props.updateAttribute(this.props.infoUserProfile.attributes, null, null, null);
    event.preventDefault();
    this.setState({
      disabelBtnUpdate: true
    });
  };
  updateAttsWithResource = (resource, values) => {
    if (this.props.infoUserProfile && this.props.infoUserProfile.attributes) {
      this.props.infoUserProfile.attributes.map(item => {
        Object.entries(this.state.infoIdentity).map(([key, val]) => {
          if (item.name === key && key === 'dateOfBirth') {
            item.value = moment(val).format(APP_LOCAL_DATE_FORMAT);
            return;
          }

          if (item.name === 'identity' && values && values.identity && !item.value) {
            item.value = values.identity;
            return;
          }

          if (item.name === 'citizenId' && values && values.identity && !item.value) {
            item.value = values.identity;
            return;
          }

          if (item.name === key) {
            item.value = this.state.infoIdentity[key] ? this.state.infoIdentity[key].trim() : this.state.infoIdentity[key];
            if (item.id == '') {
              item.id = null;
            }
            return;
          }
          if (item.value == 'Chờ phê duyệt') {
            item.value = null;
            return;
          }
        });
      });
    }
    var sic = null;
    var tax = null;
    if (this.props.infoUserProfile.userType == IND && resource == Resources[1].key) {
      sic = values.sic;
    } else if (this.props.infoUserProfile.userType == IND && resource == Resources[2].key) {
      tax = values.tax;
    }
    this.getNameSources(resource);
    this.props.updateAttribute(this.props.infoUserProfile.attributes, resource, sic, tax);
  };

  handleuploadFile = (values, file, type) => {
    // upload file
    if (type == 'COM') {
      values.active = 0;
      this.props.uploadFile(values, file);
    }
  };
  getNameSources = resource => {
    switch (resource) {
      case Resources[0].key:
        sources = Resources[0].value;
        break;
      case Resources[1].key:
        sources = Resources[1].value;
        break;
      case Resources[2].key:
        sources = Resources[2].value;
        break;
      case Resources[3].key:
        sources = Resources[3].value;
        break;
      case Resources[4].key:
        sources = Resources[4].value;
        break;
      default:
        break;
    }
  };
  handleInvalidSubmit = (event, errors, values) => {
    if (errors) {
      window['autoFocus'](errors[0]);
    }
  };
  handleChangeDate = date => {
    this.setState({
      birthday: date,
      requiredDate: false
    });
  };
  markStarOfString = (name, lbl) => {
    if (this.props.userProfile.userType === IND) {
      // case citizens
      switch (name) {
        case 'cn':
        case 'gender':
        case 'dateOfBirth':
        case 'birthPlace':
          // case 'mobile':
          return (
            <label>
              {lbl} <label style={{ color: '#FF0000' }}>*</label>
            </label>
          );
        case 'mobile':
          return <label>{lbl}</label>;
        case 'identity':
          return <label>Số CMT (9 số)</label>;
        case 'citizenId':
          return (
            <label>
              Số CMT/CCCD <label style={{ color: '#FF0000' }}>*</label>
            </label>
          );
        case 'originLocal':
        case 'permanentAddress':
        case 'mail':
          return (
            <label>
              {lbl} <label style={{ color: '#FF0000' }}>*</label>
            </label>
          );
        default:
          return;
      }
    } else if (this.props.userProfile.userType === ENP) {
      // company
      switch (name) {
        case 'organization':
          return (
            <label style={{ fontSize: '17px' }}>
              {lbl} <label style={{ color: '#FF0000' }}>*</label>
            </label>
          );
        case 'tax':
        case 'mail':
        case 'add':
          return (
            <label>
              {lbl} <label style={{ color: '#FF0000' }}>*</label>
            </label>
          );
        case 'mobile':
          return <label>{lbl}</label>;
        default:
          return;
      }
    } else if (this.props.userProfile.userType === ORG) {
      // company
      switch (name) {
        case 'organization':
        case 'unitCode':
        case 'mail':
          return (
            <label>
              {lbl} <label style={{ color: '#FF0000' }}>*</label>
            </label>
          );
        case 'unit':
        case 'mobile':
        case 'add':
          return <label>{lbl}</label>;
        default:
          return;
      }
    } else {
      return '';
    }
  };
  resetValues = () => {
    valueProvince = '';
    valueDistrict = '';
    valueWard = '';
    valueAddress = '';
    isUpdateInfo = false;
    arrWard = [];
    arrDistrict = [];
  };
  showModalSelect = type => {
    this.setState({
      isDisplayModalSelectInfo: true,
      typeInput: type
    });
    this.resetValues();
    switch (type) {
      /** Noi sinh */
      case 'birthPlace':
        let objAdd = this.props.infoUserProfile.attributes.filter(item => item.name == BORN_PLACE.ADDRESS);
        if (objAdd.length > 0) {
          valueAddress = objAdd[0].value;
        }
        let objProvince = this.props.infoUserProfile.attributes.filter(item => item.name == BORN_PLACE.PROVINCE);
        valueProvince = '';
        if (objProvince.length > 0 && objProvince[0].value != null) {
          let idProvince = this.props.arrProvince.filter(item => item.name == objProvince[0].value);
          isUpdateInfo = true;
          valueProvince = idProvince[0].id;
          this.props.getDistrict(idProvince[0].id);
        }
        break;
      /** Que quan */
      case 'originLocal':
        let objAddressLocal = this.props.infoUserProfile.attributes.filter(item => item.name == 'streetHomeTown');
        if (objAddressLocal.length > 0) {
          valueAddress = objAddressLocal[0].value;
        }
        let objProvinceLocal = this.props.infoUserProfile.attributes.filter(item => item.name == NATIVE_VILLAGE.PROVINCE);
        valueProvince = '';
        if (objProvinceLocal.length > 0 && objProvinceLocal[0].value != null) {
          let idProvinceLocal = this.props.arrProvince.filter(item => item.name == objProvinceLocal[0].value);
          isUpdateInfo = true;
          valueProvince = idProvinceLocal[0].id;
          this.props.getDistrict(idProvinceLocal[0].id);
        }
        break;
      /** Dia chi thuong tru */
      case 'permanentAddress':
        let objStreetAdd = this.props.infoUserProfile.attributes.filter(item => item.name == 'streetPermanentAddress');
        if (objStreetAdd.length > 0) {
          valueAddress = objStreetAdd[0].value;
        }
        let provinceAdd = this.props.infoUserProfile.attributes.filter(item => item.name == RESIDENT.PROVINCE);
        valueProvince = '';
        if (provinceAdd.length > 0 && provinceAdd[0].value != null) {
          let idProvinceAdd = this.props.arrProvince.filter(item => item.name == provinceAdd[0].value);
          isUpdateInfo = true;
          valueProvince = idProvinceAdd[0].id;
          this.props.getDistrict(idProvinceAdd[0].id);
        }
        break;
      /** Dia chi hien tai */
      case 'add':
        let objCommuneAdd = this.props.infoUserProfile.attributes.filter(item => item.name == ADD.ADDRESS);
        if (objCommuneAdd.length > 0) {
          valueAddress = objCommuneAdd[0].value;
        }
        let objProvinceAdd = this.props.infoUserProfile.attributes.filter(item => item.name == ADD.PROVINCE);
        valueProvince = '';
        if (objProvinceAdd.length > 0 && objProvinceAdd[0].value != null) {
          let idProvinceAdd = this.props.arrProvince.filter(item => item.name == objProvinceAdd[0].value);
          isUpdateInfo = true;
          valueProvince = idProvinceAdd[0].id;
          this.props.getDistrict(idProvinceAdd[0].id);
        }
        break;
      default:
        break;
    }
  };
  handleResetFieldInput = type => {
    switch (type) {
      case 'birthPlace':
        this.setState({
          birthPlace: '',
          isClearBirthPlace: true
        });
        break;
      case 'originLocal':
        this.setState({
          originLocal: '',
          isClearOriginLocal: true
        });
        this.props.dictInfoSelect.stateHomeTown = '';
        this.props.dictInfoSelect.districtHomeTown = '';
        this.props.dictInfoSelect.wardHomeTown = '';
        this.props.dictInfoSelect.streetHomeTown = '';
        break;
      case 'permanentAddress':
        this.setState({
          permanentAddress: '',
          isClearPermanentAddress: true
        });
        this.props.dictInfoSelect.statePermanentAddress = '';
        this.props.dictInfoSelect.districtPermanentAddress = '';
        this.props.dictInfoSelect.wardPermanentAddress = '';
        this.props.dictInfoSelect.streetPermanentAddress = '';
        break;
      case 'add':
        this.setState({
          currentAddress: '',
          isClearCurrentAddress: true
        });
        this.props.dictInfoSelect.stateCurrentAddress = '';
        this.props.dictInfoSelect.districtCurrentAddress = '';
        this.props.dictInfoSelect.wardCurrentAddress = '';
        this.props.dictInfoSelect.streetCurrentAddress = '';
        break;
    }
  };
  renderButton = () => {
    return (
      <Button
        style={{ marginBottom: '13px' }}
        className={window.innerWidth < 500 ? 'btn-identity-mobile' : 'btn-identity-web'}
        type="submit"
        onClick={() => this.setState({ stringType: claim.IDENTITY })}
        disabled={this.state.disabelBtnUpdate}
        block
      >
        <span>Cập nhật</span>
      </Button>
    );
  };
  renderInputUpdate = (item, dataRequest) => {
    switch (item.name) {
      case 'cn':
        return (
          <AvField
            name={item.name}
            value={item.value}
            type="text"
            validate={{
              required: { value: true, errorMessage: translate('register.messages.validate.fullname.required') },
              maxLength: { value: 50, errorMessage: translate('register.messages.validate.fullname.maxLength') }
            }}
          />
        );
      case 'gender':
        return (
          <AvField
            name={item.name}
            type="select"
            value={item.value}
            validate={{
              required: { value: true, errorMessage: translate('register.messages.validate.gender.required') }
            }}
          >
            <option value="">{translate('global.form.gender.placeholder')}</option>
            <option value={1}>Nam</option>
            <option value={2}>Nữ</option>
          </AvField>
        );
      case 'identity':
        // if (item.value != null) {
        //   if (item.value != 'Chờ phê duyệt') {
        return (
          <AvField
            name={item.name}
            value={item.value}
            type="text"
            validate={{
              pattern: {
                value: '^([0-9]{9})+$',
                errorMessage: 'Số cmt phải có 9 kí tự số'
              },
              maxLength: { value: 9, errorMessage: '' }
            }}
          />
        );
      //   } else {
      //     return <label style={{ color: '#ff7518c7', fontSize: '18px', fontWeight: 'bold' }}>Chờ phê duyệt</label>;
      //   }
      // } else {
      //   return this.renderButton();
      // }

      case 'citizenId':
        // if (item.value != null) {
        //   if (item.value != 'Chờ phê duyệt') {
        return (
          <AvField
            name={item.name}
            value={item.value}
            type="text"
            // validate={{
            //   pattern: {
            //     value: '^([0-9]{12})+$',
            //     errorMessage: 'Số cmt/cccd (12 số) phải có 12 kí tự số.'
            //   },
            //   maxLength: { value: 12, errorMessage: translate('register.messages.validate.cmt/cccd.minlength') }
            // }}
          />
        );
      //   } else {
      //     return <label style={{ color: '#ff7518c7', fontSize: '18px', fontWeight: 'bold' }}>Chờ phê duyệt</label>;
      //   }
      // } else {
      //   return this.renderButton();
      // }

      case 'unitCode':
        initialDataORG.unitCode = item.value;
        return (
          <AvField
            name={item.name}
            value={item.value}
            type="text"
            // validate={{
            //   required: { value: true, errorMessage: 'Bạn phải nhập mã đơn vị' },
            //   maxLength: { value: 20, errorMessage: 'Mã đơn vị quá dài' }
            // }}
          />
        );
      case 'dateOfBirth':
        initialDataIND.dob = item.value;
        let _value = new Date(formatterDate(item.value)).toDateString() != 'Invalid Date' ? new Date(formatterDate(item.value)) : null;
        return (
          <div>
            <div className="hiddenDate">
              <AvField name={item.name} value={formatterDate(item.value)} type="hidden" />
            </div>
            <ComponentDatePicker
              name=""
              value={this.state.birthday ? this.state.birthday : _value}
              required={this.state.requiredDate}
              handleChange={this.handleChangeDate}
              label=""
              placeHolder="dd/mm/yyyy"
            />
          </div>
        );
      case 'birthPlace':
        return (
          <Col className="input_container">
            <AvField
              className="input"
              style={{ backgroundColor: 'white' }}
              name={item.name}
              value={this.state.isClearBirthPlace || this.state.isChangeBirthPlace ? this.state.birthPlace : item.value}
              type="text"
              validate={{
                required: { value: true, errorMessage: translate('register.messages.validate.birthPlace.required') },
                maxLength: { value: 250, errorMessage: translate('register.messages.validate.birthPlace.maxLength') }
              }}
              onClick={() => this.showModalSelect('birthPlace')}
            />
            <Button className="input_img btnDelete" onClick={() => this.handleResetFieldInput(item.name)}>
              <FontAwesomeIcon icon={faTimes} color={colors.iconDelete} />
            </Button>
          </Col>
        );
      case 'originLocal':
        return (
          <Col className="input_container">
            <AvField
              className="input"
              style={{ backgroundColor: 'white' }}
              name={item.name}
              value={this.state.isClearOriginLocal || this.state.isChangeOriginLocal ? this.state.originLocal : item.value}
              type="text"
              validate={{
                maxLength: { value: 250, errorMessage: translate('register.messages.validate.originLocal.maxLength') }
              }}
              readOnly={true}
              onClick={() => this.showModalSelect('originLocal')}
            />
            <Button className="input_img btnDelete" onClick={() => this.handleResetFieldInput(item.name)}>
              <FontAwesomeIcon icon={faTimes} color={colors.iconDelete} />
            </Button>
          </Col>
        );
      case 'permanentAddress':
        return (
          <Col className="input_container">
            <AvField
              className="input"
              style={{ backgroundColor: 'white' }}
              name={item.name}
              value={this.state.isClearPermanentAddress || this.state.isChangePermanentAddress ? this.state.permanentAddress : item.value}
              type="text"
              validate={{
                maxLength: {
                  value: 250,
                  errorMessage: translate('register.messages.validate.permanentAddress.maxLength')
                }
              }}
              readOnly={true}
              onClick={() => this.showModalSelect('permanentAddress')}
            />
            <Button className="input_img btnDelete" onClick={() => this.handleResetFieldInput(item.name)}>
              <FontAwesomeIcon icon={faTimes} color={colors.iconDelete} />
            </Button>
          </Col>
        );
      case 'add':
        return (
          <Col className="input_container">
            <AvField
              className="input"
              style={{ backgroundColor: 'white' }}
              name={item.name}
              value={this.state.isClearCurrentAddress || this.state.isChangeCurrentAddress ? this.state.currentAddress : item.value}
              type="text"
              validate={{
                required: { value: true, errorMessage: 'Bạn phải nhập địa chỉ.' },
                maxLength: { value: 250, errorMessage: translate('register.messages.validate.add.maxLength') }
              }}
              readOnly={true}
              onClick={() => this.showModalSelect('add')}
            />
            <Button className="input_img btnDelete" onClick={() => this.handleResetFieldInput(item.name)}>
              <FontAwesomeIcon icon={faTimes} color={colors.iconDelete} />
            </Button>
          </Col>
        );
      case 'tax':
        if (this.props.userProfile.userType === '2') {
          return (
            <AvField
              name={item.name}
              value={item.value}
              type="text"
              validate={{
                required: {
                  value: this.props.userProfile.userType === ENP ? true : false,
                  errorMessage: translate('register.messages.validate.tax.required')
                },
                maxLength: { value: 50, errorMessage: translate('register.messages.validate.tax.maxLength') }
              }}
              readOnly={true}
            />
          );
        } else {
          return;
        }
      case 'mobile':
        initialDataIND.mobile = dataRequest && dataRequest.mobile ? dataRequest.mobile : item.value;
        initialDataORG.mobile = dataRequest && dataRequest.mobile ? dataRequest.mobile : item.value;
        return (
          <AvField
            name={item.name}
            value={dataRequest && dataRequest.mobile ? dataRequest.mobile : item.value}
            validate={{
              // required: {
              //   value: this.props.userProfile.userType == IND ? true : false,
              //   errorMessage: 'Bạn phải nhập số điện thoại.'
              // },
              number: { value: true, errorMessage: translate('global.messages.validate.mobile.invalid') },
              minLength: { value: 10, errorMessage: translate('global.messages.validate.mobile.minlength') },
              maxLength: { value: 11, errorMessage: translate('global.messages.validate.mobile.maxlength') },
              pattern: { value: '^[0-9]+$', errorMessage: 'Số điện thoại không được chứa khoảng trắng' }
            }}
            autoComplete="off"
          />
        );
      case 'mail':
        initialDataIND.email = dataRequest && dataRequest.mail ? dataRequest.mail : item.value;
        initialDataORG.email = dataRequest && dataRequest.mail ? dataRequest.mail : item.value;
        return (
          <AvField
            name={item.name}
            value={dataRequest && dataRequest.mail ? dataRequest.mail : item.value}
            type="email"
            validate={{
              required: {
                errorMessage: translate('register.messages.validate.email.required')
              },
              email: { value: true, errorMessage: translate('register.messages.validate.email.pattern') },
              maxLength: { value: 250, errorMessage: translate('register.messages.validate.email.maxLength') }
            }}
          />
        );
      case 'organization':
        initialDataORG.organization = item.value;
        if (this.props.userProfile.userType == ENP || this.props.userProfile.userType === ORG) {
          return (
            <AvField
              name={item.name}
              value={item.value}
              type="text"
              // validate={{
              //   required: {
              //     value: true,
              //     errorMessage:
              //       this.props.userProfile.userType == ENP
              //         ? translate('register.messages.validate.companyName.required')
              //         : 'Bạn phải nhập tên tổ chức.'
              //   },
              //   maxLength: { value: 250, errorMessage: translate('register.messages.validate.companyName.maxLength') }
              // }}
            />
          );
        } else {
          return;
        }
      case 'unit':
        return (
          <AvField
            name={item.name}
            value={item.value}
            type="text"
            validate={{
              // required: { value: true, errorMessage: translate('register.messages.validate.unit.required') },
              maxLength: { value: 250, errorMessage: translate('register.messages.validate.unit.maxLength') }
            }}
          />
        );
      default:
        return;
    }
  };
  renderIcon = (attrLoa, value) => {
    return null;
    // if (value) {
    //   if (attrLoa) return <FontAwesomeIcon icon={faCheckCircle} color={colors.colorSuccess} />;
    //   return <FontAwesomeIcon icon={faExclamationTriangle} color={colors.colorWarning} />;
    // }
    // return <FontAwesomeIcon icon={faArrowAltCircleRight} color={colors.colorDanger} />;
  };
  closeModalSelectInfo = () => {
    this.setState({
      isDisplayModalSelectInfo: false
    });
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  selectInfo = (id, type) => {
    isUpdateInfo = false;
    switch (type) {
      case 'province':
        arrWard = [];
        valueAddress = '';
        valueDistrict = '';
        this.props.getDistrict(id);
        break;
      case 'district':
        valueAddress = '';
        valueWard = '';
        this.props.getGuild(id);
        break;
      default:
        break;
    }
  };
  handleConfirm = (dict, type) => {
    let address = '';
    let guild = '';
    let district = '';
    let province = '';
    if (dict.addressHome !== '') {
      address = dict.addressHome + ', ';
    }
    if (dict.guild !== '') {
      guild = dict.guild + ', ';
    }
    if (dict.district !== '') {
      district = dict.district + ', ';
    }
    if (dict.province !== '') {
      province = dict.province;
    }
    let str = address + guild + district + province;
    switch (type) {
      case 'birthPlace':
        this.props.dictInfoSelect.stateBirthPlace = dict.province;
        this.props.dictInfoSelect.districtBirthPlace = dict.district;
        this.props.dictInfoSelect.wardBirthPlace = dict.guild;
        this.props.dictInfoSelect.streetBirthPlace = dict.addressHome;
        this.setState({
          birthPlace: str,
          isChangeBirthPlace: true
        });
        break;
      case 'originLocal':
        this.props.dictInfoSelect.stateHomeTown = dict.province;
        this.props.dictInfoSelect.districtHomeTown = dict.district;
        this.props.dictInfoSelect.wardHomeTown = dict.guild;
        this.props.dictInfoSelect.streetHomeTown = dict.addressHome;
        this.setState({
          originLocal: str,
          isChangeOriginLocal: true
        });
        break;
      case 'permanentAddress':
        this.props.dictInfoSelect.statePermanentAddress = dict.province;
        this.props.dictInfoSelect.districtPermanentAddress = dict.district;
        this.props.dictInfoSelect.wardPermanentAddress = dict.guild;
        this.props.dictInfoSelect.streetPermanentAddress = dict.addressHome;
        this.setState({
          permanentAddress: str,
          isChangePermanentAddress: true
        });
        break;
      case 'add':
        this.props.dictInfoSelect.stateCurrentAddress = dict.province;
        this.props.dictInfoSelect.districtCurrentAddress = dict.district;
        this.props.dictInfoSelect.wardCurrentAddress = dict.guild;
        this.props.dictInfoSelect.streetCurrentAddress = dict.addressHome;
        this.setState({
          currentAddress: str,
          isChangeCurrentAddress: true
        });
        break;
    }
    this.closeModalSelectInfo();
  };
  invokeCloseModalConfirm = () => {
    this.setState({
      isDisplayModalConfirm: false
    });
  };
  invokeAgree = () => {
    this.setState({
      isDisplayModalConfirm: false
    });
    this.updateInfo(this.state.dataInput);
  };
  filterIdentityInfoWithUserType = type => {
    if (type == IND) {
      return this.props.infoUserProfile && this.props.infoUserProfile.attributes
        ? this.props.infoUserProfile.attributes.filter(
            item =>
              item.name == 'cn' ||
              item.name == 'identity' ||
              item.name == 'citizenId' ||
              item.name == 'dateOfBirth' ||
              item.name == 'mobile' ||
              item.name == 'mail'
          )
        : [];
    } else if (type == ENP) {
      return this.props.infoUserProfile && this.props.infoUserProfile.attributes
        ? this.props.infoUserProfile.attributes.filter(item => item.name == 'organization' || item.name == 'tax')
        : [];
    } else if (type == ORG) {
      return this.props.infoUserProfile && this.props.infoUserProfile.attributes
        ? this.props.infoUserProfile.attributes.filter(
            item => item.name == 'organization' || item.name == 'unitCode' || item.name == 'mobile' || item.name == 'mail'
          )
        : [];
    } else {
      return [];
    }
  };
  filterIdentityInfoOtherWithUserType = type => {
    if (type == IND) {
      return this.props.infoUserProfile && this.props.infoUserProfile.attributes
        ? this.props.infoUserProfile.attributes.filter(
            item =>
              item.name == 'gender' ||
              item.name == 'birthPlace' ||
              item.name == 'originLocal' ||
              item.name == 'permanentAddress' ||
              item.name == 'mail'
          )
        : [];
    } else if (type == ENP) {
      return this.props.infoUserProfile && this.props.infoUserProfile.attributes
        ? this.props.infoUserProfile.attributes.filter(item => item.name == 'mobile' || item.name == 'mail' || item.name == 'add')
        : [];
    } else if (type == ORG) {
      return this.props.infoUserProfile && this.props.infoUserProfile.attributes
        ? this.props.infoUserProfile.attributes.filter(
            item => item.name == 'unit' || item.name == 'mobile' || item.name == 'mail' || item.name == 'add'
          )
        : [];
    } else {
      return [];
    }
  };
  closeModalResources = () => {
    this.setState({
      displayModalResources: false
    });
  };
  closeModalAttributed = () => {
    this.setState({
      showModalAttribute: false,
      birthday: null
    });
    this.props.invokeCloseModal();
  };
  closeAlert = () => {
    this.setState({
      showMessageError: false,
      displayModalResources: false,
      messageError: ''
    });
    this.props.invokeCloseModal();
  };

  cancelRequest = () => {
    this.props.handleDeleteUserByIdApprove(this.props.resUserInfoApprove[0].id);
  };

  render() {
    var dataRequest = null;
    if (this.props.resUserInfoApprove && this.props.resUserInfoApprove.length > 0) {
      dataRequest = JSON.parse(this.props.resUserInfoApprove[0].requestData);
    }
    var arrTemp = [];
    arrTemp = arrKeyIND;
    if (this.props.userProfile.userType == ENP) {
      arrTemp = arrKeyENP;
    }
    if (this.props.userProfile.userType == ORG) {
      arrTemp = arrKeyORG;
    }
    return (
      <div className="container-fluid">
        <MessageModal
          type={SUCCESS}
          showModal={this.state.showMessage}
          message={'Gửi duyệt thành công ! thông tin sẽ được chuyển đến quản trị viên phê duyệt.'}
        />
        <ModalSelectInfo
          showModal={this.state.isDisplayModalSelectInfo}
          type={this.state.typeInput}
          handleConfirm={this.handleConfirm}
          handleClose={this.closeModalSelectInfo}
          handleSelectInfo={this.selectInfo}
          arrProvince={this.props.arrProvince ? this.props.arrProvince : []}
          arrDistrict={arrDistrict}
          arrCommune={arrWard}
          valueProvince={valueProvince}
          valueDistrict={valueDistrict}
          valueCommune={valueWard}
          valueAddress={valueAddress}
        />
        <MessageModal type={SUCCESS} showModal={this.state.showMessageUpdateInfo} message={'Chúc mừng bạn đã cập nhật thành công.'} />
        <MessageModalConfirm
          showModalConfirm={this.state.isDisplayModalConfirm}
          invokeCancel={this.invokeCloseModalConfirm}
          message={this.state.messageConfirm}
          invokeAgree={this.invokeAgree}
        />
        <ModalUpdateAttribute
          display={this.state.showModalAttribute}
          attribute={this.props.resUpdateAttr}
          handleClose={this.closeModalAttributed}
          verifyResidentailFail={this.state.isVerifyResidentialFail}
        />
        <ModalResources
          type={this.state.stringType}
          display={this.state.displayModalResources}
          closeModal={this.closeModalResources}
          userProfile={this.props.infoUserProfile}
          updateAttribute={this.updateAttsWithResource}
          uploadFile={this.handleuploadFile}
        />

        <AlertMessage showModal={this.state.showMessageError} message={this.state.messageError} closeAlert={this.closeAlert} />
        <Modal
          className="modal-lg hide-border-bottom-modal"
          isOpen={this.props.isDisplay}
          toggle={this.toggle}
          size="lg"
          backdrop="static"
          centered={window.location === window.parent.location}
          style={{ maxWidth: window.innerWidth < 768 ? '100%' : '90%' }}
        >
          <ModalHeader toggle={this.toggle}>
            <h3 className="font-weight-bold">Thông tin tài khoản</h3>
            <span style={{ color: '#FF9900' }}>
              {this.props.type === 'UPDATE' && this.props.resUserInfoApprove.length > 0 ? 'Chờ phê duyệt' : ''}
            </span>
          </ModalHeader>
          <ModalBody className="custom-scrollbar" style={{ paddingTop: '0px', height: '550px', overflow: 'auto' }}>
            {/*<div style={{ textAlign: 'center' }}>*/}
            {/*  <label className="font-weight-bold">Thông tin định danh</label>*/}
            {/*</div>*/}
            <Alert id="myAlert" color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
              {this.state.message}
            </Alert>
            <AvForm id="updateUser-form" onValidSubmit={this.handleValidSubmitIdentityInfo} onInvalidSubmit={this.handleInvalidSubmit}>
              <div style={{ border: '1px solid #C9C9C9', padding: '15px', marginBottom: '20px' }}>
                {this.filterIdentityInfoWithUserType(this.props.userProfile.userType).map((item, index) => (
                  <div className="row">
                    <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-3'}>{this.markStarOfString(item.name, item.label)}</div>
                    <div className={window.innerWidth < 768 ? 'col-10' : 'col-sm-6'}>{this.renderInputUpdate(item, dataRequest)}</div>
                    <div className={window.innerWidth < 768 ? 'col-2' : 'col-sm-3'} style={{ textAlign: 'center' }}>
                      {arrTemp.includes(item.name) ? this.renderIcon(item.loa, item.value) : null}
                    </div>
                  </div>
                ))}
                <div className="row justify-content-center">
                  <div className={window.innerWidth < 768 ? 'col-6' : 'col-sm-3'}>
                    <Button
                      className="btn-register-white"
                      style={{
                        float: 'right',
                        marginTop: '10px',
                        marginBottom: '10px',
                        height: '40px'
                      }}
                      type="button"
                      block
                      onClick={this.toggle}
                    >
                      <span>Bỏ qua</span>
                    </Button>
                  </div>
                  <div className={window.innerWidth < 768 ? 'col-6' : 'col-sm-3'}>
                    <Button
                      className="btn-register"
                      style={{ marginTop: '10px', height: '40px' }}
                      type="submit"
                      disabled={this.state.disabelBtnUpdate}
                      block
                    >
                      <span>Cập nhật</span>
                    </Button>
                  </div>
                </div>
                {/*<div>*/}
                {/*  <Button*/}
                {/*    className="btn-register"*/}
                {/*    style={{ margin: '10px auto', width: window.innerWidth < 768 ? '50%' : '20%' }}*/}
                {/*    type="submit"*/}
                {/*    onClick={() => this.setState({ stringType: 'null' })}*/}
                {/*    disabled={this.state.disabelBtnUpdate}*/}
                {/*    block*/}
                {/*  >*/}
                {/*    <span>Cập nhật</span>*/}
                {/*  </Button>*/}
                {/*</div>*/}
              </div>
            </AvForm>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  arrProvince: storeState.userInfo.province,
  district: storeState.userInfo.district,
  guild: storeState.userInfo.guild,
  userProfile: storeState.userInfo.userProfile,
  resUpdateAttr: storeState.userInfo.resUpdateAttr,
  approval: storeState.userInfo.appovalData,
  resultData: storeState.userInfo.resultData,
  listFile: storeState.userInfo.listFile,
  resultUpdate: storeState.userInfo.resultUpdate,
  resUserInfoApprove: storeState.userInfo.resInfoApprove,
  resDeleteUserApprove: storeState.approveManagement.resDeleteUserApprove
});
const mapDispatchToProps = {
  getDistrict,
  getGuild,
  updateAttribute,
  uploadFile,
  getFile,
  appovalCreate,
  updateAccount,
  handleDeleteUserByIdApprove,
  handleGetUserInfo
};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateIdentity);
